import React from 'react';
import { ChevronRight, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-b from-primary to-[#0D0520] text-center relative overflow-hidden" data-id="element-89" data-mp="3udyh9qdhwlk3">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse,rgba(124,58,237,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-90" data-mp="c83pjkbwtm5j" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-91" data-mp="m2vl6ilxlyxo">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center text-left" data-id="element-92" data-mp="h4u0jt8uxrk3">
          
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-3xl overflow-hidden border border-gold/20 shadow-[0_20px_50px_rgba(0,0,0,0.4)]" data-id="element-93" data-mp="vtykpfz7q5uu">
            <img src="https://cdn.magicpatterns.com/uploads/qkSkioRpp24ApPbHS6hEHG/Airplane_window_viewing_clouds_s…_202608241742.jpg" alt="De el algún día al hoy" className="w-full h-auto object-cover" data-id="element-94" data-mp="zxo7q108ofdr" />
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-95" data-mp="2m19gnj39gkak">
            <h2 className="font-display text-3xl md:text-4xl lg:text-[48px] font-black leading-tight mb-6 text-white" data-id="element-96" data-mp="2v4257el26hwp">
              Tu vida soñada te está<br data-id="element-97" data-mp="300snm8kc5pla" />
              <span className="text-gradient-violet" data-id="element-98" data-mp="30093cl77qp43">esperando desde hace tiempo.</span>
            </h2>
            
            <p className="text-lg text-gray-400 mb-10 leading-relaxed" data-id="element-99" data-mp="39s5fh064wfrb">
              No dejes que otro mes pase mientras el "termostato de escasez" sigue controlando tu realidad. Por el precio de un café, activa el sistema que cambia tu frecuencia para siempre.
            </p>
            
            <div className="inline-block w-full" data-id="element-100" data-mp="1joczkidfp7yn">
              <a href="https://pay.hotmart.com/I106896154S?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'InitiateCheckout', {
                  value: 9.99,
                  currency: 'USD',
                  content_name: 'Pack Merezco la Vida de mis Sueños'
                });
              }
            }} className="flex items-center justify-center gap-2.5 w-full bg-gradient-to-br from-violet to-violet-dark text-white font-body text-lg font-bold px-8 py-5 rounded-xl shadow-[0_8px_32px_rgba(124,58,237,0.4)] hover:shadow-[0_12px_40px_rgba(124,58,237,0.6)] hover:-translate-y-0.5 transition-all" data-id="element-101" data-mp="1jp4vjuay17pg">
                <ChevronRight className="w-6 h-6" data-id="element-102" data-mp="d0eo40aut2qu" />
                QUIERO EMPEZAR MI TRANSFORMACIÓN
              </a>
              
              <p className="flex items-center justify-center gap-1.5 mt-4 text-[13px] text-gray-500" data-id="element-103" data-mp="2x9hhm9l9llj">
                <Lock className="w-3.5 h-3.5" data-id="element-104" data-mp="6x1r82apxxsh" />
                Pago seguro · Acceso inmediato · Garantía 7 días
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}